import { html } from "lit-html";
import { ifDefined } from "lit/directives/if-defined.js";

import { SCAbstractVideoPlayer } from "./sc-m-abstract-video-player";

export interface VideoPlayerTemplateParameter<T> {
  component: SCAbstractVideoPlayer<T>;
}

const getPosterImage = <T>(component: SCAbstractVideoPlayer<T>) => {
  if (component.posterSrc === undefined) {
    return "";
  }

  return html`
    <button class="sc-m-abstract-video-player__play-cta" aria-label="Play">
      <sc-e-lazy-image
        class="sc-e-lazy-image sc-js-lazy-image"
        src="${ifDefined(component.posterSrc)}"
        srcset="${ifDefined(component.posterSrcSet)}"
        sizes="${ifDefined(component.posterSizes)}"
        loading-placeholder=${ifDefined(component.posterLoadingPlaceholder)}
        alt="${ifDefined(component.posterAlt)}"
        title="${ifDefined(component.posterTitle)}"
        aspect-ratio="16:9"
      >
      </sc-e-lazy-image>
      <div class="sc-m-abstract-video-player__play-icon-box">
        <sc-e-icon class="sc-m-abstract-video-player__play-icon" icon-id="sc-icon-play"></sc-e-icon>
      </div>
      <div class="sc-m-abstract-video-player__loading-spinner">
        <div class="sc-m-abstract-video-player__loading-bounce"></div>
        <div class="sc-m-abstract-video-player__loading-bounce"></div>
      </div>
    </button>
  `;
};

export const videoPlayerTemplate = <T>(args: VideoPlayerTemplateParameter<T>) => {
  return html`
    <div class="sc-m-abstract-video-player__video" id="${args.component.playerContainerID}"></div>
    ${getPosterImage<T>(args.component)}
  `;
};
